/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { ManageProducts } from './ManageProducts'
import useUser from '../../Shared/UserProvider/useUser'

const ActionsBar = () => {
    const { user } = useUser()
    const companyCanCreateItems = user.provider.type === 'COMPANY' || user.canCreateItems

    if (!companyCanCreateItems) {
        return null
    }

    return (
      <div
        css={css`
            display: flex;
            justify-content: flex-end;
        `}
      >
          <ManageProducts />
      </div>
    )
}

export { ActionsBar }
